// extracted by mini-css-extract-plugin
module.exports = {"ShareListWrapper":"ShareList_ShareListWrapper__QXGk4","ShareListMoreOptionsWrapper":"ShareList_ShareListMoreOptionsWrapper__nfkkm"};